import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5aa399e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "display-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "display-flex",
  style: {"width":"60% !important","margin-left":"1%","float":"left"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"2rem !important","font-style":"italic","font-weight":"700 !important"} }, "SCAN-PC"),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red","font-weight":"bold","margin-left":"2%"} }, "PORD with SMC goes to the Spare Parts and Accessories page.")
], -1 /* HOISTED */))
const _hoisted_4 = { style: {"width":"40% !important","margin-right":"2%","float":"right"} }
const _hoisted_5 = {
  key: 0,
  class: "display-flex"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"font-size":"2rem !important","width":"40%"} }, "Station Code:", -1 /* HOISTED */))
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"right","font-size":"2rem !important","font-style":"italic"}
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"border":"solid 1px"} }, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "display-flex margin-top" }
const _hoisted_11 = { class: "button-position" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-book" }, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { style: {"margin-left":"5px"} }, "Upload History", -1 /* HOISTED */))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Navigation"]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          ($setup.store.getters.stationCode == '1000')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDestination) = $event)),
                  class: "adjusting-position form-select des-select",
                  style: {"width":"60%"}
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.destinationList, (destination, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: index,
                      value: destination.stationCode
                    }, _toDisplayString(destination.stationCode) + " : " + _toDisplayString(destination.companyName), 9 /* TEXT, PROPS */, _hoisted_7))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $setup.selectedDestination]
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, " Station Code:" + _toDisplayString($setup.store.getters.stationCode), 1 /* TEXT */))
        ])
      ]),
      _hoisted_9
    ]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-width",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.outputUploadHistoryByCSV()))
        }, _hoisted_14)
      ])
    ]),
    _createVNode($setup["PcUploadArea"], {
      onChangeAlertState: $setup.ChangeAlertState,
      onAlertMessageValue: $setup.alertMessageValue
    })
  ]))
}